angular.module('impactx.list').service('ListPrintService', ListPrintService);

ListPrintService.$inject = ['$window', '$config', '$securityManager', '$httpParamSerializerJQLike'];

/**
 * Service for printing lists
 * @param dataGen Data service
 * @constructor
 */
function ListPrintService($window, $config, $securityManager) {

    /**
     * Print the list; i.e. call
     */
    this.printExcel = function (config, params, printEndpoint) {
        var form = document.createElement('form');
        form.action = $config.sourceURL + (printEndpoint ? printEndpoint : "/print/list/excel");
        form.method = 'POST';
        form.target = '_blank';
        form.style.display = 'none';

        var input = document.createElement('input');
        input.type = 'text';
        input.name = 'token';
        input.value = $securityManager.getToken();

        var input2 = document.createElement('input');
        input2.name = 'config';
        input2.value = angular.toJson(config);

        var paramsInput = document.createElement('input');
        paramsInput.name = 'params';
        paramsInput.value = angular.toJson(params);

        var submit = document.createElement('input');
        submit.type = 'submit';
        submit.id = 'submitForm';

        form.appendChild(input);
        form.appendChild(input2);
        form.appendChild(paramsInput);
        form.appendChild(submit);
        document.body.appendChild(form);

        $('#submitForm').click();

        document.body.removeChild(form);
    };

    this.printExcelClient = function (headers, rows) {
        var form = document.createElement('form');
        form.action = $config.sourceURL + "/print/list/client/excel";
        form.method = 'POST';
        form.target = 'print';
        form.style.display = 'none';

        var inputt = document.createElement('input');
        inputt.type = 'text';
        inputt.name = 'token';
        inputt.value = $securityManager.getToken();

        angular.forEach(headers, function (value, key) {
            var input = document.createElement('input');
            input.type = 'text';
            input.name = 'headers';
            input.value = angular.toJson(value)
            form.appendChild(input);
        });

        var input2 = document.createElement('input');
        input2.name = 'rows';
        input2.value = angular.toJson(rows);

        var submit = document.createElement('input');
        submit.type = 'submit';
        submit.id = 'submitForm';

        form.appendChild(input2);
        form.appendChild(inputt);
        form.appendChild(submit);
        document.body.appendChild(form);

        $('#submitForm').click();

        document.body.removeChild(form);
    }
}
